// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"styles_headerWrapper__8uyQk","mainHeader":"styles_mainHeader__bxgrB","headerMenu":"styles_headerMenu__oODj1"};